import type { BloodCrimesShortPublication, BloodCrimesYouTubeCase } from './api';

export interface BloodCrimesCaseFileCalendarEntry {
  id: string;
  caseId: string;
  caseNumber: number;
  title: string;
  format: 'LONG' | 'SHORT';
  platform: string;
  scheduledAt: string;
  contentId: string | null;
}

/** Calendar entries are actual pending schedules only. `plannedPublishAt` is
 * a production estimate and must not be presented as a reserved slot. */
export function buildBloodCrimesCaseFileCalendar(
  cases: ReadonlyArray<BloodCrimesYouTubeCase>,
  publications: ReadonlyArray<BloodCrimesShortPublication>,
): BloodCrimesCaseFileCalendarEntry[] {
  const entries: BloodCrimesCaseFileCalendarEntry[] = [];

  for (const item of cases) {
    const publish = item.data.youtubePublish;
    if (!publish || typeof publish !== 'object' || Array.isArray(publish)) continue;
    const state = publish as { status?: unknown; scheduledAt?: unknown; title?: unknown };
    if (state.status !== 'SCHEDULED' || typeof state.scheduledAt !== 'string' || !Number.isFinite(Date.parse(state.scheduledAt))) continue;
    entries.push({
      id: `${item.id}:LONG`, caseId: item.id, caseNumber: item.caseNumber,
      title: typeof state.title === 'string' && state.title.trim() ? state.title : item.topic,
      format: 'LONG', platform: 'YOUTUBE', scheduledAt: state.scheduledAt, contentId: null,
    });
  }

  for (const publication of publications) {
    for (const platform of publication.platforms) {
      if (platform.scheduleStatus !== 'PENDING' || typeof platform.scheduledAt !== 'string' || !Number.isFinite(Date.parse(platform.scheduledAt))) continue;
      entries.push({
        id: `${publication.caseId}:${publication.shortId}:${platform.platform}`,
        caseId: publication.caseId, caseNumber: publication.caseNumber, title: publication.title,
        format: 'SHORT', platform: platform.platform, scheduledAt: platform.scheduledAt,
        contentId: publication.contentId,
      });
    }
  }

  return entries.sort((left, right) => Date.parse(left.scheduledAt) - Date.parse(right.scheduledAt)
    || left.caseNumber - right.caseNumber || left.platform.localeCompare(right.platform));
}
